import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { ObjectStoreCreateForm } from "./components/ObjectStoreCreateForm";

export function NewObjectStorePage() {
  return (
    <LqsPage title="New Object Store">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <ObjectStoreCreateForm />
      </Container>
    </LqsPage>
  );
}
